export function secondsToHHMM(seconds) {
  if (!seconds) return "00:00";
  let hours = Math.floor(+seconds / 3600);
  let minutes = Math.floor((+seconds % 3600) / 60);
  if (hours < 10) hours = `0${hours}`;
  if (minutes < 10) minutes = `0${minutes}`;
  return `${hours}:${minutes}`;
}

export const buildDepartmentAndTeamOptions = ({
  departmentAll = [],
  teamAll = [],
  userExtraData = {},
}) => {
  let departmentOptions = [];
  let teamOptions = [];

  // Departments
  if (departmentAll && departmentAll.length) {
    departmentOptions = departmentAll.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }

  if (!userExtraData?.department) {
    departmentOptions.unshift({
      value: "",
      label: "All Departments",
    });
  }

  // Teams
  if (teamAll && teamAll.length) {
    teamOptions = teamAll.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }

  if (!userExtraData?.team) {
    teamOptions.unshift({
      value: "",
      label: "All Teams",
    });
  }

  return {
    departmentOptions,
    teamOptions,
  };
};

export function floorSeconds(seconds) {
  const floorSecs = Math.floor(+seconds / 60) * 60;
  return floorSecs;
}

export function secondsToHours(seconds) {
  const hours = (seconds / 3600).toFixed(2);
  return hours;
}

export function toTitleCase(name) {
  if (!name || !name.length) return true;
  const newName = name.toLowerCase();
  return newName[0].toUpperCase() + newName.slice(1);
}

export function exportFile(data, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    const a = document.createElement("download");
    document.body.appendChild(a);
    a.style.display = "none";
    a.onclick = (evx) => {
      const myBlob = new Blob([data.action.payload], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      window.navigator.msSaveOrOpenBlob(myBlob, filename);
    };
    a.click();
  }
  // chrome ,safari and mozilla browsers
  else {
    const myBlob = new Blob([data.action.payload], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(myBlob);
    const element = document.createElement("a");
    document.body.appendChild(element);
    element.href = url;
    element.download = filename;
    element.click();
  }
}

export function exportTextFile(data, filename) {
  const textData = new TextDecoder().decode(data.action.payload);
  const correctedText = textData.replace(/\\n/g, "\n").replace(/"/g, "");

  const myBlob = new Blob([correctedText], { type: "text/plain" });

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(myBlob, filename);
  } else {
    const url = window.URL.createObjectURL(myBlob);
    const element = document.createElement("a");
    document.body.appendChild(element);
    element.href = url;
    element.download = filename;
    element.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(element);
  }
}

export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
    reader.onerror = (error) => reject(error);
  });
}

/**
 *
 * function is used to add all the adjustment data in their respective keys
 *
 * @export
 * @param {Array} list : list will be an array which will be
 * @param {string} key : will be the key used fetch all the data under it
 * @return {Array} : Array of object with sum of their keys
 */
export function tallyLists(list, key) {
  let result = [];
  // eslint-disable-next-line no-unused-expressions
  list?.forEach((item) => {
    // eslint-disable-next-line no-unused-expressions
    item?.[key]?.forEach((adjItem) => {
      let existing = result.find((r) => r.name === adjItem.name);
      if (existing) {
        existing.regular_time += adjItem.regular_time;
        existing.over_time += adjItem.over_time;
        existing.double_over_time += adjItem.double_over_time;
      } else {
        result.push({ ...adjItem });
      }
    });
  });
  return result?.length > 0 ? result : [];
}

export default {
  secondsToHHMM,
  secondsToHours,
  floorSeconds,
  toTitleCase,
  exportFile,
  exportTextFile,
  convertToBase64,
};
